module.exports = __webpack_public_path__ + "img/Caregiver-(1)home.edc16426.jpg";